import React, { useEffect, useState } from 'react'

import { useMerchantData } from '@contexts/admin/MerchantDataContext'
import ListPageHeader from '@shared/ListPageHeader'
import ShelvesList from '@shared/shelves/ShelvesList'

import { shelfService } from '@services/admin/shelfService'
import { warehouseService } from '@services/admin/warehouseService'

export default function AdminShelvesList() {
  const { shelfTypes } = useMerchantData()
  const [warehouses, setWarehouses] = useState([])

  useEffect(() => {
    (async () => {
      try {
        const data = await warehouseService.fetchList()
        if (data.data) setWarehouses(data.data)
      } catch (err) {
        console.error('Failed to fetch warehouses:', err)
      }
    })()
  }, [])

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['data', 'shelves']}
      />
      <ShelvesList
        shelfTypes={shelfTypes}
        service={shelfService}
        role="admin"
        showMerchantColumn={false}
        warehouses={warehouses}
      />
    </div>
  )
}
